import axios from "./productInstance"
import { UpdateOrderIndexRequest } from '@/types/productV2'



export default async (list: UpdateOrderIndexRequest) => {


	try {
		const response: any = await axios.patch(`/productProfiles/order`, list)
		return response.data
	} catch (error) {
		return null
	}
}

/*
	{id, order_index}
 */
